import React, { useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material";
import { Form, useForm } from "../../components/hooks/useForm";
import CheckBoxControl from "../../components/controls/CheckBoxControl";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { API_URL } from "../../api/axios";
import LoadingComp from "../../components/LoadingComp";

const BlogsDetail = ({ loadingEditForm, singleBlogs }) => {
  const initialFormValues = {
    blog_image: "",
    blog_name: "",
    blog_slug: "",
    blog_description: "",
    status: 0,
  };

  const { values, setValues } = useForm(initialFormValues);

  useEffect(() => {
    if (singleBlogs) {
      setValues({ ...singleBlogs });
    }
  }, [singleBlogs, setValues]);

  return (
    <Form>
      {loadingEditForm ? (
        <LoadingComp />
      ) : (
        <>
          <Grid container spacing={2} style={{ fontSize: "12px" }}>
            <Grid item xs={12}>
              <TextField
                name="blog_name"
                label="Blog Name"
                InputProps={{
                  style: {
                    pointerEvents: "none",
                  },
                }}
                value={values.blog_name}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12}>
              <CKEditor
                editor={ClassicEditor}
                disabled
                id="blog_description"
                name="blog_description"
                onReady={(editor) => {
                  editor.setData(values.blog_description);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CheckBoxControl
                name="status"
                label="Active"
                value={values.status}
                onChange={() => ""}
              />
            </Grid>

            <Grid item xs={12}>
              {singleBlogs?.blog_image && singleBlogs?.blog_image ? (
                <img
                  alt=""
                  src={
                    singleBlogs &&
                    `${API_URL}/uploads/blogs/${singleBlogs?.blog_image}`
                  }
                  height={150}
                  width={150}
                />
              ) : (
                <span style={{ color: "red" }}>*Choose Image</span>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </Form>
  );
};

export default BlogsDetail;
